type WhiteLabel = 'mrbilit' | 'airplaneticket';
export type Deployment = 'web' | 'android' | 'ios';

interface RunModeToken {
    development?: string;
    production?: string;
}

interface WhiteLabelConfig {
    url: string;
    deploymentToken?: {
        ios?: string | RunModeToken;
        android?: string | RunModeToken;
        web?: string | RunModeToken;
    };
    sourceId?: number | Record<Deployment, number>;
}

const whiteLabelConfig: Record<WhiteLabel, WhiteLabelConfig> = {
    mrbilit: {
        url: 'mrbilit.com',
        deploymentToken: {
            ios: {
                production:
                    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJidXMiOiI0ZiIsInRybiI6IjE3Iiwic3JjIjoiMjAifQ.StKiVflAP9XaZ9oZ66Z-wylDy0lMLywxaK4p0LhEtes',
                development:
                    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJidXMiOiI0ZiIsInRybiI6IjE3Iiwic3JjIjoiMjAifQ.cjZJjxIdqNL-xjHR-ZXQFDwj5_MSd0yL-g7YS-QeP_A',
            },
            android: {
                production:
                    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJidXMiOiI0ZiIsInRybiI6IjE3Iiwic3JjIjoiMTkifQ.6KTTGRLxbLEISAFPbFermpmsLtFdJOIaBdOD5BD6sRo',
                development:
                    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJidXMiOiI0ZiIsInRybiI6IjE3Iiwic3JjIjoiMTkifQ.h8Xa_O8Pvy4ZSxxUb-_xcrGjbfBTWp8QNmuTumqE_bA',
            },
            web: {
                production:
                    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJidXMiOiI0ZiIsInRybiI6IjE3Iiwic3JjIjoiMiJ9.vvpr9fgASvk7B7I4KQKCz-SaCmoErab_p3csIvULG1w',
                development:
                    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJidXMiOiI0ZiIsInRybiI6IjE3Iiwic3JjIjoiMiJ9.COR8Stf8oCNM5-BrboMRRY3DCWb5M0Iu9mFjQnYavwk',
            },
        },
        sourceId: {
            web: 2,
            android: 19,
            ios: 20,
        },
    },
    airplaneticket: {
        url: 'airplaneticket.ir',
        deploymentToken: {
            web: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJidXMiOiI0ZiIsInRybiI6IjE3Iiwic3JjIjoiMSJ9.600MMoO_rUITgmUGqxd7rkBQp9nhhjh0vmY-yG0tfXQ',
        },
        sourceId: 1,
    },
};

export const useWhiteLabel = () => {
    const runEnv = useRunEnv();
    const runMode = runEnv === 'dev' ? 'development' : 'production';
    let whiteLabel: WhiteLabel = 'mrbilit';
    let deployment: Deployment = 'web';
    if (typeof process !== 'undefined' && process?.server) {
        whiteLabel = (process.env.NUXT_PUBLIC_WHITE_LABEL ||
            'mrbilit') as WhiteLabel;
        deployment = (process.env.NUXT_PUBLIC_DEPLOYMENT ||
            'web') as Deployment;
    } else {
        const runtimeConfig = useRuntimeConfig();
        whiteLabel = (runtimeConfig.public.whiteLabel ||
            'mrbilit') as WhiteLabel;
        deployment = (runtimeConfig.public.deployment || 'web') as Deployment;
    }
    const isMrbilit = computed(() => whiteLabel === 'mrbilit');
    const isAirplaneTicket = computed(() => whiteLabel === 'airplaneticket');
    const urlDeploymentPrepend = computed(() => {
        switch (deployment) {
            case 'android':
                return 'android.';
            case 'ios':
                return 'ios.';
            default:
                return '';
        }
    });
    const urlModePrepend = computed(() => {
        switch (runEnv) {
            case 'dev':
                return 'dev.';
            case 'staging':
                return 'staging.';
            default:
                return '';
        }
    });
    const whiteLabelUrl = computed(
        () =>
            `https://${urlDeploymentPrepend.value}${urlModePrepend.value}${whiteLabelConfig[whiteLabel].url}`
    );
    const defaultToken = computed<string>(() => {
        const currentConfig =
            whiteLabelConfig[whiteLabel].deploymentToken?.[deployment];
        if (typeof currentConfig === 'string') {
            return currentConfig;
        } else {
            return currentConfig?.[runMode] ?? '';
        }
    });
    const sourceId = computed(() => {
        const currentSource = whiteLabelConfig[whiteLabel].sourceId;
        if (typeof currentSource === 'number') {
            return currentSource;
        } else {
            return currentSource?.[deployment] ?? 2;
        }
    });
    return {
        whiteLabel,
        isMrbilit,
        isAirplaneTicket,
        whiteLabelUrl,
        defaultToken,
        sourceId,
    };
};
